module.exports = __webpack_public_path__ + "static/img/head11.4054cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head11.png
// module id = Q8JK
// module chunks = 1